import createReducer from "./reducerUtils";
import {
  LOAD_CLAVE_DOBLE_FACTOR_USUARIO,
  LOADING_CLAVE_DOBLE_FACTOR_USUARIO,
  LOADING_GENERAR_CLAVE_DOBLE_FACTOR,
  LOADING_VALIDAR_CLAVE_DOBLE_FACTOR,
} from "../actions/actionTypes";

const initialState = {
  claveDobleFactorUsuario: {
    lista: [],
  },
  loadingClaveDobleFactorUsuario: false,
  loadingGenerarClaveDobleFactor: false,
  loadingValidarClaveDobleFactor: false,
};

const listarClaveDobleFactorUsuario = (state, payload) => {
  return {
    ...state,
    claveDobleFactorUsuario: payload.claveDobleFactorUsuario,
  };
};

const loadingClaveDobleFactorUsuario = (state, payload) => {
  return { ...state, loadingClaveDobleFactorUsuario: payload.loading };
};

const loadingGenerarClaveDobleFactor = (state, payload) => {
  return { ...state, loadingGenerarClaveDobleFactor: payload.loading };
};

const loadingValidarClaveDobleFactor = (state, payload) => {
  return { ...state, loadingValidarClaveDobleFactor: payload.loading };
};

export default createReducer(initialState, {
  [LOAD_CLAVE_DOBLE_FACTOR_USUARIO]: listarClaveDobleFactorUsuario,
  [LOADING_CLAVE_DOBLE_FACTOR_USUARIO]: loadingClaveDobleFactorUsuario,
  [LOADING_GENERAR_CLAVE_DOBLE_FACTOR]: loadingGenerarClaveDobleFactor,
  [LOADING_VALIDAR_CLAVE_DOBLE_FACTOR]: loadingValidarClaveDobleFactor,
});
